import $ from 'jquery';

$(() => {
  const $downloadSelect = $('.js-download-select');

  $downloadSelect.each((index, element) => {
    const $select = $(element);
    const $parentForm = $select.closest('form');
    const $downloadButton = $parentForm.find('a');
    const $titleLink = $parentForm.parent().find('a.js-link-download');
    // const $fileTitleSpan = $titleLink.find('span.js-filename');
    const $fileSizeSpan = $titleLink.find('span.js-filesize');

    $select.on('change', () => {
      const $selectedElement = $select.find(':selected');
      const $downloadUrl = $selectedElement.data('downloadurl');
      // const $fileTitle = $selectedElement.data('filename');
      const $fileSize = $selectedElement.data('filesize');
      $downloadButton.attr('href', $downloadUrl);
      $titleLink.attr('href', $downloadUrl);
      // $fileTitleSpan.text($fileTitle);
      $fileSizeSpan.text($fileSize);
    });
  });
});



// WEBPACK FOOTER //
// ./assets/js/components/download-selected.js